export default __webpack_public_path__ + "static/06.06_Partners_logo_1024-95bede9d4f474dff017ad9b32864416a.png";